import { getToken, generateTraceId } from '@accor/customer-lib'
import { isWebView } from '@accor/customer-core'
import { i18nService } from '@accor/customer-vue-services'
import {
  buildSignInUrl,
  buildAllPlusUrl,
  getLatamPlans,
  contactCompat
} from '@/services/customerApiCompat'

const match = (re: RegExp) => navigator.userAgent.match(re)
const isMobile = {
  Android: () => !!match(/Android/i) && !isMobile.Windows(),
  BlackBerry: () => !!match(/BlackBerry/i),
  iOS: () => !!match(/iPhone|iPad|iPod/i),
  Opera: () => !!match(/Opera Mini/i),
  Windows: () => !!match(/IEMobile|Windows Phone/i),
  any: () =>
    isMobile.Android() ||
    isMobile.BlackBerry() ||
    isMobile.iOS() ||
    isMobile.Opera() ||
    isMobile.Windows()
}

export const vue2CustomerApiServices = {
  getToken,
  generateTraceId,
  ...contactCompat, // getContact, putContact, deleteContactItem (curried adapters)
  isWebView,
  isMobile,
  isIE: () => false,
  getLang: () => i18nService.getCurrentLocale(),
  Enum: (...keys: string[]) =>
    keys.reduce((acc, k) => ((acc[k] = k), acc), {} as Record<string, string>),
  Error: { RefreshTokenFailed: 'RefreshTokenFailed' } as const,
  getAuthUrl: () => buildSignInUrl(),
  getSubscriptionFunnelUrl: (opts: { funnel: string; origin?: string; lang?: string }) =>
    buildAllPlusUrl(opts),
  getPlans: getLatamPlans
}
